export const GERMANY_COUNTRY_ID = '88';
